import { render, staticRenderFns } from "./InfoDialog.vue?vue&type=template&id=5194a3e5&scoped=true"
import script from "./InfoDialog.vue?vue&type=script&lang=js"
export * from "./InfoDialog.vue?vue&type=script&lang=js"
import style0 from "./InfoDialog.vue?vue&type=style&index=0&id=5194a3e5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5194a3e5",
  null
  
)

export default component.exports